import { useEffect } from 'react';
import axios from 'axios';
import { HOST_URL } from '../constants/config.ts';

/**
 * Hook for tracking campaign referrals from URL parameters
 * Works on any page where it's imported
 */
export const useCampaignTracker = () => {
  useEffect(() => {
    try {
      // This works on any page with ?ref= parameter
      const urlParams = new URLSearchParams(window.location.search);
      const refParam = urlParams.get('ref');
      const referrer = document.referrer || '';

      // Only make the API call if ref parameter exists
      if (refParam) {
        // Make call to campaign tracking endpoint with the ref as campaign_id
        axios.post(`${HOST_URL}/campaign/track`, {
          campaignId: refParam,
          referrer: referrer,
        });
      }
    } catch (err) {}
  }, []);
};
